
export const environment = {
    SUPABASE_PROJECT_URL: 'https://rjjmqniearxbzgsxrovw.supabase.co',
    SUPABASE_CLIENT_KEY: 'sb_publishable_zppYfJnAnaPKQEiF4w0AEQ_8X0zGkbQ',
    MAPBOX_API_KEY:'pk.eyJ1IjoiZXZvbHZvIiwiYSI6ImNtYXFwM25icTAyMW4yaXNmY2hwbGZ5bHQifQ.TYxUOJYIzbRo0i2yT10AWw',
    HCAPTCHA_SECRET:'ES_5b7a196d966449e9b2063353ae21aa77',
    HCAPTCHA_SITE_KEY:'771edb38-d4e8-4880-97fe-6b3859deae2a',
    SUPABASE_APP_URL:'https://portal-dev.evolvomobility.com',
};
